var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalFolderClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 20.2795C3.95 20.2795 3.47917 20.0837 3.0875 19.692C2.69583 19.3004 2.5 18.8295 2.5 18.2795V6.27954C2.5 5.72954 2.69583 5.25871 3.0875 4.86704C3.47917 4.47537 3.95 4.27954 4.5 4.27954H10.5L12.5 6.27954H20.5C21.05 6.27954 21.5208 6.47537 21.9125 6.86704C22.3042 7.25871 22.5 7.72954 22.5 8.27954V18.2795C22.5 18.8295 22.3042 19.3004 21.9125 19.692C21.5208 20.0837 21.05 20.2795 20.5 20.2795H4.5Z",
    fill: "#F7DB79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalFolderClosed);
export default __webpack_public_path__ + "static/media/external_folder_closed.1063f27696e277069e988d3b12b57feb.svg";
export { ForwardRef as ReactComponent };